import normalMode from "../../../normalMode";
import LotteryGGLV2Prefab from "./LotteryGGLV2Prefab";
import O1HD from "../../../../../engines/gameEngine";
import LotterySuperGGLV2Prefab from "./LotterySuperGGLV2Prefab";
import NormalGameManager from "../../../manager/NormalGameManager";
import gameConfig from "../../../../../engines/configs/gameConfig";
import LotteryNewGGLV2Prefab from "./LotteryNewGGLV2Prefab";
import utilsModel from "../../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;
/**
 * 刮刮乐 中心
 */
@ccclass
export default class LotteryCenterV2Prefab extends cc.Component {

    @property({type:cc.Node})
    step1Node : cc.Node = null;
    @property({type:cc.Node})
    step2Node : cc.Node = null;
    @property({type:cc.Node,displayName:"金兔献瑞"})
    step3Node : cc.Node = null;
    @property({type:cc.Node,displayName:"新刮刮乐"})
    step4Node : cc.Node = null;

    @property({type:cc.Node})
    shadow : cc.Node = null;
    @property({type:cc.Node})
    btnGGLNode : cc.Node = null;
    @property({type:cc.Node})
    btnSuperGGLNode : cc.Node = null;
    @property({type:cc.Node})
    btnGoldGGLNode : cc.Node = null;
    @property({type:cc.Node})
    btnNewGGLNode : cc.Node = null;

    @property({type:cc.Node})
    adPurchaseBtnNode : cc.Node = null;

    @property(cc.Prefab)
    lotteryGGLPrefab : cc.Prefab = null;
    @property(cc.Prefab)
    lotteryNewGGLPrefab : cc.Prefab = null;
    @property(cc.Prefab)
    lotterySuperGGLPrefab : cc.Prefab = null;
    @property({type:cc.Label,displayName:"价格"})
    lbPrize : cc.Label = null;

    //超级刮刮乐
    private _currChoose : number = 0;//0 ggl ，1 超级刮刮乐
    private mParentScript : normalMode;
    private clickStr : string;//点击序列
    private mGameLayer : NormalGameManager;

    onLoad () {
        this.mGameLayer = NormalGameManager._instance;
    }

    start () {
        this.refreshBtn();
    }

    bindData( parentScript : normalMode ){
        this.mParentScript = parentScript;
        if ( this.mParentScript.gameManager.getGameData().goldGGLSwitch ) {
            this.btnGoldGGLNode.active = true;
        }
    }

    changeContent(){
        let seconds = 0.3;
        switch ( this._currChoose ) {
            case 0 :
                this.step3Node.active = false;
                this.step2Node.active = false;
                this.step4Node.active = false;
                this.step1Node.y = 1300;
                this.step1Node.active = true;
                cc.tween( this.step1Node )
                    .to( seconds,{y:240})
                    .start()

                break;
            case 1:
                this.step1Node.active = false;
                this.step3Node.active = false;
                this.step4Node.active = false;
                this.step2Node.y = 1300;
                this.step2Node.active = true;
                cc.tween( this.step2Node )
                    .to( seconds,{y:240})
                    .start()
                break;
            case 2:
                this.step1Node.active = false;
                this.step2Node.active = false;
                this.step3Node.y = 1300;
                this.step3Node.active = true;
                this.step4Node.active = false;
                cc.tween( this.step3Node )
                    .to( seconds,{y:240})
                    .start()
                break;
            case 3:
                this.step1Node.active = false;
                this.step2Node.active = false;
                this.step3Node.active = false;
                this.step4Node.y = 1300;
                this.step4Node.active = true;
                cc.tween( this.step4Node )
                    .to( seconds,{y:240})
                    .start()
                break;
                break;
        }

        this.shadow.scale = 0.1;
        cc.tween( this.shadow )
            .to( seconds , { scale : 1 })
            .start();
    }

    /**
     * 刮刮乐
     */
    onBtnGGL( e ){
        this.clickStr += "0";
        if ( this.btnGGLNode.getChildByName("checked").active ) {
            return;
        };
        this.lbPrize.string = `20`;
        this._bigBtnNode( this.btnGGLNode );
        this._smallBtnNode( this.btnSuperGGLNode );
        this._smallBtnNode( this.btnGoldGGLNode );
        this._smallBtnNode( this.btnNewGGLNode );
        this._currChoose = 0;
        this.changeContent();
        this.refreshBtn();
    }

    /**
     * 超级刮刮乐
     */
    onBtnSuperGGL( e ){
        this.clickStr += "1";
        if ( this.mParentScript.gameManager.getCurrentDay() >= 4 && this.clickStr.includes( "00011" ) == true ) {
            this.mParentScript.gameManager.setGameData({ goldGGLSwitch : 1 }, false );
            this.btnGoldGGLNode.active = true;
        }
        if ( this.btnSuperGGLNode.getChildByName("checked").active ) {
            return;
        }
        this.lbPrize.string = `20`;
        this._smallBtnNode( this.btnGGLNode );
        this._bigBtnNode( this.btnSuperGGLNode );
        this._smallBtnNode( this.btnGoldGGLNode );
        this._smallBtnNode( this.btnNewGGLNode );
        this._currChoose = 1;
        this.changeContent();
        this.refreshBtn();
    }


    /**
     * 黄金
     */
    private _smallBtnNode( node : cc.Node ){
        cc.tween( node.getChildByName("checked") )
            .to(0.1,{ scale : 0.9 })
            .call(()=>{
                node.getChildByName("checked").active = false;
            })
            .start();
    }

    private _bigBtnNode( node : cc.Node ){
        node.getChildByName("checked").scale = 0.9;
        node.getChildByName("checked").active = true;
        cc.tween( node.getChildByName("checked") )
            .to(0.1,{ scale : 1 })
            .call(()=>{
                // node.getChildByName("checked").active = false;
            })
            .start();
    }

    /**
     * 黄金刮刮乐
     */
    onBtnGoldGGL(  ){
        if ( this.btnGoldGGLNode.getChildByName("checked").active ) {
            return;
        }
        this.lbPrize.string = `40`;
        this._smallBtnNode( this.btnGGLNode );
        this._smallBtnNode( this.btnSuperGGLNode );
        this._bigBtnNode( this.btnGoldGGLNode );
        this._smallBtnNode( this.btnNewGGLNode );
        this._currChoose = 2;
        this.changeContent();
        this.refreshBtn();
    }

    /**
     *
     */
    onBtnNewGGL(){
        if ( this.btnNewGGLNode.getChildByName("checked").active ) {
            return;
        }
        this.lbPrize.string = `10000`;
        this._smallBtnNode( this.btnGGLNode );
        this._smallBtnNode( this.btnSuperGGLNode );
        this._smallBtnNode( this.btnGoldGGLNode );
        this._bigBtnNode( this.btnNewGGLNode );
        this._currChoose = 3;
        this.changeContent();
        this.refreshBtn();
    }

    /**
     * 购买
     */
    onBtnPurchase( e ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let needPayPrice : number = 20;
        switch ( this._currChoose ) {
            case 0:
                break;
            case 1:
                break;
            case 2:
                needPayPrice = 40;
                break;
            case 3:
                needPayPrice = 10000;
                break;
            default:
                needPayPrice = 20;
                break;
        }

        if ( O1HD.getServices().userSrv.getCoins() < needPayPrice ) {
            O1HD.getModules().uiControlModule.showMessageBox("金额不足",this.node );
            
            NormalGameManager._instance.openBankPage();
            return;
        }
        O1HD.getServices().userSrv.setCoins(-needPayPrice,true );

        this._purchaseSuccess();
        this.refreshBtn();
    }

    private _purchaseSuccess(){
        if ( this._currChoose == 0 ){
            //打开福兔 献瑞
            let lotteryGGLPrefabNode = cc.instantiate( this.lotteryGGLPrefab );
            this.node.addChild( lotteryGGLPrefabNode );
            lotteryGGLPrefabNode.getComponent( LotteryGGLV2Prefab ).bindData( this, false );
            this.mGameLayer.getGameData().lotteryInfo.currGGLPurchaseCount ++;
        }else if( this._currChoose == 1 ){
            //打开 超级刮刮乐
            let lotterySuperGGLPrefabNode = cc.instantiate( this.lotterySuperGGLPrefab );
            lotterySuperGGLPrefabNode.getComponent( LotterySuperGGLV2Prefab ).bindData( this );
            this.node.addChild( lotterySuperGGLPrefabNode );
            this.mGameLayer.getGameData().lotteryInfo.currSuperGGLPurchaseCount ++;
        }else if( this._currChoose == 2 ) {
            let lotteryGGLPrefabNode = cc.instantiate( this.lotteryGGLPrefab );
            this.node.addChild( lotteryGGLPrefabNode );
            lotteryGGLPrefabNode.getComponent( LotteryGGLV2Prefab ).bindData( this, true );
            this.mGameLayer.getGameData().lotteryInfo.currGJGGLPurchaseCount ++;
        }else if ( this._currChoose == 3 ){
            let lotteryNewGGLPrefabNode = cc.instantiate( this.lotteryNewGGLPrefab );
            this.node.addChild( lotteryNewGGLPrefabNode );
            lotteryNewGGLPrefabNode.getComponent( LotteryNewGGLV2Prefab ).bindData( this );
            this.mGameLayer.getGameData().lotteryInfo.currNewGGLPurchaseCount ++;
        }
        this.mGameLayer.writeGameData();
    }

    /**
     * 广告购买
     */
    onBtnAdPurchase(){
        this.adPurchaseBtnNode.active = false;
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this._purchaseSuccess();
            this.refreshBtn();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"彩票解锁");
    }

    refreshBtn(){
        let lotteryInfo = this.mGameLayer.getGameData().lotteryInfo;
        switch ( this._currChoose ) {
            case 0:
                if ( lotteryInfo.currGGLPurchaseCount >= gameConfig.GGL_CURR_LIMIT ) {
                    // 显示看视频购买按钮
                    this.adPurchaseBtnNode.active = true;
                }else{
                    this.adPurchaseBtnNode.active = false;
                }
                break;
            case 1:
                if ( lotteryInfo.currSuperGGLPurchaseCount >= gameConfig.SUPER_GGL_CURR_LIMIT ) {
                    // 显示看视频购买按钮
                    this.adPurchaseBtnNode.active = true;
                }else{
                    this.adPurchaseBtnNode.active = false;
                }
                break;
            case 2:
                if ( lotteryInfo.currGJGGLPurchaseCount >= gameConfig.HJGGL_CURR_LIMIT ) {
                    // 显示看视频购买按钮
                    this.adPurchaseBtnNode.active = true;
                }else{
                    this.adPurchaseBtnNode.active = false;
                }
                break;
            case 3:
                if ( lotteryInfo.currNewGGLPurchaseCount >= gameConfig.NEW_GGL_CURR_LIMIT ) {
                    // 显示看视频购买按钮
                    this.adPurchaseBtnNode.active = true;
                }else{
                    this.adPurchaseBtnNode.active = false;
                }
                break;
        }
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.node.removeFromParent();
        this.node.destroy();
    }
}
